import { Link } from "react-router-dom";
import logo from "../graphics/logo.svg";

const Resetpwd = () => {
  return (
    <div className="common-section">
      <div className="container px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center py-8">
          {/* Logo */}
          <div className="flex justify-center mb-6">
            <img
              src={logo}
              alt="Twinge Health Logo"
              className="w-[180px] md:w-[220px] lg:w-[250px] h-auto"
            />
          </div>

          {/* Reset Password Form Container */}
          <div className="login-form-container rounded-3xl sm:rounded-[32px] md:rounded-[40px] p-4 sm:p-6 md:p-8 lg:p-12 overflow-hidden relative w-full max-w-md sm:max-w-lg md:max-w-xl" style={{ backgroundColor: "var(--neutral-100)" }}>
            <h3 className="h3 mb-6 w-full" style={{ textAlign: 'center' }}>
              Reset your password
            </h3>
            
            {/* Description Text */}
            <div style={{ textAlign: 'center' }}>
              <p className="body1 text-center mb-6">
                Tell us where to send a password reset link to.
              </p>
            </div>

            {/* Wavy Line Separator */}
            <div className="flex justify-center mb-6">
                <svg viewBox="0 0 122 10" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-[92px] md:w-[122px]">
                  <path
                    opacity="0.4"
                    d="M1.46484 6.83613L4.45387 3.7103C7.74598 0.267505 13.38 0.760513 16.0241 4.72277L16.5428 5.50001C19.2423 9.54539 25.1877 9.54539 27.8873 5.5V5.5C30.5869 1.45461 36.5322 1.45461 39.2318 5.5V5.5C41.9314 9.54539 47.8768 9.54539 50.5764 5.5V5.5C53.2759 1.45461 59.2213 1.45461 61.9209 5.5V5.5C64.6205 9.54539 70.5658 9.54539 73.2654 5.5V5.5C75.965 1.45461 81.9104 1.45461 84.61 5.5V5.5C87.3096 9.54539 93.2549 9.54539 95.9545 5.5V5.5C98.6541 1.45461 104.599 1.45461 107.299 5.5V5.5C109.999 9.54539 115.944 9.54539 118.644 5.5L120.534 2.66667"
                    stroke="var(--primary-500)"
                    strokeLinecap="round"
                  />
                </svg>
              </div>
            
            <form className="w-full flex flex-col items-left" id="resetPasswordForm">
              <div className="flex flex-col gap-5 w-full">
                {/* Email Input */}
                <div className="flex flex-col gap-2">
                  <label htmlFor="email" className="h6 text-theme-text-secondary">
                    Email Address *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    placeholder="Enter your email"
                    required
                    className="w-full px-4 py-3 border border-neutral-300 rounded-lg focus:border-primary-500 focus:ring-2 focus:ring-primary-200 focus:outline-none transition-all duration-200 bg-white custom-placeholder"
                  />
                </div>

                {/* Back to Login Row */}
                <div className="flex items-center justify-center gap-3 mb-4">
                  <Link to="/login" className="caption2 transition-colors duration-200" style={{ color: 'var(--primary-500)', textDecoration: 'none' }}>
                    Back to login
                  </Link>
                </div>

                {/* Reset Password Button */}
                <div className="flex justify-center gap-4">
                  <button
                    type="submit"
                    className="btn btn-primary btn-lg"
                  >
                    Reset Password
                  </button>
                </div>

              </div>
            </form>
          </div>

          {/* Sign Up Link */}
          <div style={{ marginTop: "32px", textAlign: 'center' }}>
            <p className="body1 text-sm text-theme-text-secondary">
              New to Twinge Health? 
              <Link to="/signup" className="caption2 font-medium transition-colors duration-200" style={{ color: 'var(--primary-500)', textDecoration: 'none' }}>
                &nbsp;Create account
              </Link>
            </p>
            <p className="body1 text-sm text-theme-text-secondary" style={{ marginTop: "16px" }}>
              Need help? 
              <a 
                href="https://twingehealth.com/contact-us" 
                target="_blank" 
                rel="noopener noreferrer"
                className="caption2 font-medium transition-colors duration-200" 
                style={{ color: 'var(--primary-500)', textDecoration: 'none' }}
              >
                &nbsp;Contact us
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Resetpwd;
